module.exports = __webpack_public_path__ + "img/g8.1ffa2270.jpg";